import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import EmployeeSelect from "../../../components/formItems/EmployeeSelect";
import DateTimePicker from "../../../components/formItems/DateTimePicker";
import PredefinedSelectItem from "../../../components/formItems/PredefinedSelectItem";
import moment from "moment";
import { useSelector } from "react-redux";
import { getHouseVisitSettings } from "../../../api/server";

const Planning = (props) => {
  const {
    control,
    approved,
    activeHouseVisit,
    loading,
    setProffesionalEmployees,
    enabled,
    changedValues,
    changedItems,
    type,
  } = props;
  const intl = useIntl();
  const { scopePrefix } = useSelector((state) => state.auth);
  const orgDiffLimit = useSelector(
    (state) => state.organization.details.months_between_house_visits
  );
  const [monthLimit, setMonthLimit] = useState(null);
  const professionalFilter = {
    $and: [
      {
        $or: [
          { professional_role_id: 1 },
          { professional_role_id: 2 },
          { professional_role_id: 3 },
          { professional_role_id: 4 },
          { controller: true },
        ],
      },
      { $or: [{ status: 1 }, { status: 3 }] },
    ],
  };

  const onDataChanged = (employees) => {
    setProffesionalEmployees(employees);
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await getHouseVisitSettings({
        scopePrefix,
        patientId: activeHouseVisit.patient__id,
      });
      const limit = result?.data?.months_between_visits || orgDiffLimit;
      setMonthLimit(limit);
    };
    if (activeHouseVisit) {
      fetchData().catch(console.error);
    }
  }, [activeHouseVisit]);

  const dateStr = changedItems.includes("date")
    ? changedValues["date"]
    : activeHouseVisit["date"];
  // Parse the previousVisit and dateToCheck using moment
  const previousVisit = moment(activeHouseVisit["previous_visit__date"]);
  const dateToCheck = moment(dateStr);

  // Calculate the last permitted date by adding monthLimit to the previousVisit month
  const lastPermittedDate = previousVisit
    .clone()
    .add(monthLimit, "months")
    .endOf("month");

  // Extract the year and month components of the dates
  const previousVisitYear = previousVisit.year();
  const previousVisitMonth = previousVisit.month(); // month() is zero-based, January is 0 and December is 11
  const dateToCheckYear = dateToCheck.year();
  const dateToCheckMonth = dateToCheck.month();

  // Calculate the difference in months
  const yearDifference = dateToCheckYear - previousVisitYear;
  const monthDifference = dateToCheckMonth - previousVisitMonth;
  const totalMonthDifference = yearDifference * 12 + monthDifference;

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.planning",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <EmployeeSelect
          name="planned_employee_id"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.planned_employee_id",
          })}
          params={{
            filter: professionalFilter,
            scopePrefix:
              activeHouseVisit.patient__branch &&
              `branches/${activeHouseVisit.patient__branch}/`,
          }}
          disabled={approved || !enabled}
          proffesional={true}
          loading={loading}
          onDataChanged={onDataChanged}
        />
        <DateTimePicker
          name="date"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.date",
          })}
          disabled={approved || !enabled}
          loading={loading}
          extraDetail={
            type !== "new" &&
            totalMonthDifference &&
            `${totalMonthDifference} ${intl.formatMessage({
              id: "app.mobile.forms.house_visits.months",
            })}`
          }
          presentation={"date-time"}
          extraDetailColor={
            dateToCheck.isSameOrBefore(lastPermittedDate) ? "success" : "danger"
          }
          isDateEnabled={(dateIsoString) => {
            // parse the date string
            const date = new Date(dateIsoString);
            // return false if it's a Saturday
            return date.getDay() !== 6;
          }}
        />
        <PredefinedSelectItem
          name="duration_minutes"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.duration_minutes",
          })}
          duration={true}
          disabled={approved || !enabled}
          loading={loading}
        />
      </IonCardContent>
    </IonCard>
  );
};

export default Planning;
